import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { NotificationMessage, NotificationType } from '../../shared/models/misc';
import { ToastNotificationService } from '../../atoms/toast-notification/toast-notification.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService implements OnDestroy {
  private readonly toast = inject(ToastNotificationService);
  private readonly notificationSubject = new Subject<NotificationMessage>();
  private readonly subscriptionList = new Subscription();

  constructor() {
    this.subscriptionList.add(
      this.notificationSubject.subscribe({
        next: (notification) => {
          const typeMap: Record<NotificationType, 'success' | 'warning' | 'error' | 'info'> = {
            [NotificationType.success]: 'success',
            [NotificationType.warning]: 'warning',
            [NotificationType.error]: 'error',
            [NotificationType.info]: 'info',
          };

          void this.toast.alert({
            title: 'Notification',
            message: notification.message,
            type: typeMap[notification.type] ?? 'info',
            icon: typeMap[notification.type] ?? 'info',
          });
        },
      }),
    );
  }

  sendMessage(message: Omit<NotificationMessage, 'timestamp'>): void {
    this.notificationSubject.next({
      ...message,
      timestamp: new Date(),
    });
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }
}
